import { Form, Input, Modal, Select } from 'antd';
import { productWantRequestUpdateStatus } from 'apis/product-want-request';
import LOCALS from 'commons/locals';
import { useEffect, useMemo, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { PmsProductWantRequestStatus } from 'types/pms-product-want-request';
import { getWantRequestStatusSelectOptions } from './common';

type PendingStatusChange = {
  id: number;
  fromStatus: PmsProductWantRequestStatus;
  toStatus: PmsProductWantRequestStatus;
};

type Props = {
  pending?: PendingStatusChange;
  onClose: () => void;
  onSuccess: () => void;
};

const StatusUpdateModal = ({ pending, onClose, onSuccess }: Props) => {
  const { t } = useTranslation();
  const [form] = Form.useForm<{ remark?: string }>();
  const [submitting, setSubmitting] = useState(false);

  const statusSelectOptions = useMemo(
    () => getWantRequestStatusSelectOptions(t),
    [t],
  );

  useEffect(() => {
    if (pending) {
      form.resetFields();
    }
  }, [pending, form]);

  const handleOk = async () => {
    if (!pending) return;
    try {
      const values = await form.validateFields();
      setSubmitting(true);
      await productWantRequestUpdateStatus(pending.id, {
        status: pending.toStatus,
        remark: values.remark,
      });
      onSuccess();
      onClose();
    } catch {
      // validation or api error
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title={<Trans i18nKey={LOCALS.pwr_change_status} />}
      open={!!pending}
      onCancel={onClose}
      onOk={handleOk}
      confirmLoading={submitting}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item label={<Trans i18nKey={LOCALS.pwr_new_status} />}>
          <Select
            disabled
            value={pending?.toStatus}
            options={statusSelectOptions}
          />
        </Form.Item>
        <Form.Item label={<Trans i18nKey={LOCALS.remark} />} name="remark">
          <Input.TextArea
            rows={3}
            placeholder={t(LOCALS.pwr_status_remark_placeholder) || ''}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default StatusUpdateModal;
